export const addExpense = (expense) => {
    return(dispatch, getState, {getFirebase, getFirestore}) => {
        //Make async call to the database to store the data
     const firestore = getFirestore();
     firestore.collection('addExpense').add({
         ...expense
     }).then(()=>{
        dispatch({type: 'ADD_EXPENSE', expense});
     }).catch((err)=>{
        dispatch({type: 'ADD_EXPENSE_ERROR', err});
     })
     
    }
}; 